import { render } from "./statuses.vue?vue&type=template&id=2dc067ed"
import script from "./statuses.vue?vue&type=script&lang=js"
export * from "./statuses.vue?vue&type=script&lang=js"

import "./statuses.vue?vue&type=style&index=0&id=2dc067ed&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__